import { createFileRoute } from '@tanstack/react-router';
import { FormResponsesTab } from '@web/modules/forms/responses/form-responses-tab';

/** `?response=<id>` opens that response (the link copied from it, the lead's page). */
export const Route = createFileRoute('/_app/capture/forms/$formId/responses')({
  validateSearch: (search: Record<string, unknown>): { response?: string } =>
    typeof search['response'] === 'string' && search['response'] !== ''
      ? { response: search['response'] }
      : {},
  component: FormResponsesTab,
});
